import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  constructor() { }

  public addGtm(gtmId: string): void {
    if (!gtmId) {
      console.error('GTM ID is missing');
      return;
    }

    // Controlla se GTM è già stato aggiunto
    if (document.getElementById('gtm-script')) {
      return;
    }

    // Aggiungi lo script nell'header
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.type = 'text/javascript';
    script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`;
    document.head.appendChild(script);

    // Aggiungi il noscript nel body
    const noScript = document.createElement('noscript');
    noScript.innerHTML = `<iframe"https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noScript);
  }

  /**
   * Metodo per inviare eventi personalizzati a GTM
   * @param eventName Nome dell'evento (es. 'button_click')
   * @param eventParams Parametri dell'evento (es. { category: 'user', action: 'click', label: 'signup_button' })
   */
  public pushEvent(eventName: string, eventParams: any = {}): void {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.push({
      event: eventName,
      ...eventParams
    });
    console.log('Evento GTM inviato:', eventName, eventParams);
  }
}